import React from "react";
import AuthGuard from "hoc/AuthGuard";
import { PracticeMainScreen } from "design-system/template/practice/practice-main-screen/practice-main-screen";

const PracticePage = () => {
  return (
    <AuthGuard>
      <PracticeMainScreen />
    </AuthGuard>
  );
};

export default PracticePage;
